import {
  Scene, Mesh, SphereGeometry, MeshBasicMaterial,
  Vector3, Color,
} from 'three';

interface Particle {
  mesh: Mesh;
  velocity: Vector3;
  life: number;
  maxLife: number;
}

export class Explosion {
  private particles: Particle[] = [];
  private geo = new SphereGeometry(1, 4, 4);

  constructor(private scene: Scene) {}

  spawnSmall(pos: Vector3): void {
    this.spawn(pos, 4, 0.3, 0xffaa00);
  }

  spawnLarge(pos: Vector3): void {
    this.spawn(pos, 12, 0.8, 0xff4400);
  }

  private spawn(pos: Vector3, count: number, life: number, baseColor: number): void {
    for (let i = 0; i < count; i++) {
      const mat = new MeshBasicMaterial({
        color: new Color(baseColor),
        transparent: true,
        opacity: 1,
      });
      const mesh = new Mesh(this.geo, mat);
      mesh.position.copy(pos);
      const scale = 2 + Math.random() * 4;
      mesh.scale.setScalar(scale);

      const vel = new Vector3(
        (Math.random() - 0.5) * 80,
        (Math.random() - 0.5) * 80,
        (Math.random() - 0.5) * 80,
      );
      this.scene.add(mesh);
      this.particles.push({ mesh, velocity: vel, life, maxLife: life });
    }
  }

  update(delta: number): void {
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const p = this.particles[i];
      p.life -= delta;
      p.mesh.position.addScaledVector(p.velocity, delta);
      p.mesh.scale.multiplyScalar(1 + delta * 2);
      const mat = p.mesh.material as MeshBasicMaterial;
      mat.opacity = Math.max(0, p.life / p.maxLife);

      if (p.life <= 0) {
        this.scene.remove(p.mesh);
        mat.dispose();
        this.particles.splice(i, 1);
      }
    }
  }
}
